import { LicensePlan } from '../../types';

export const m365GovernmentPlans: LicensePlan[] = [
  {
    id: 'gcc',
    name: 'Microsoft 365 GCC',
    description: 'For US Federal, State, Local, and Tribal governments',
    pricing: {
      points: [
        { amount: null, currency: 'USD', unit: 'user/month', effective: '1970-01-01', label: 'Contact Sales' }
      ]
    },
    compliance: [
      'FedRAMP High',
      'DFARS',
      'CJIS',
      'IRS 1075',
      'HIPAA'
    ],
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'GCC environment' },
      { name: 'SharePoint Online', included: true, additionalInfo: 'GCC environment' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Office Apps', included: true },
      { name: 'OneDrive for Business', included: true },
      { name: 'US Government Community Support', included: true },
      { name: 'US Data Center Locations', included: true },
      { name: 'DFARS Compliance', included: true },
      { name: 'FedRAMP High', included: true },
      { name: 'Microsoft Defender for Cloud Apps', included: true },
      { name: 'Microsoft Defender for Office 365', included: true },
      { name: 'Teams Phone System', included: true, additionalInfo: 'Calling Plan sold separately' },
      { name: 'Power BI Pro', included: false, additionalInfo: 'Add-on available' },
    ]
  },
  {
    id: 'gcc-high',
    name: 'Microsoft 365 GCC High',
    description: 'For DOD contractors and federal agencies with ITAR/EAR requirements',
    pricing: {
      points: [
        { amount: null, currency: 'USD', unit: 'user/month', effective: '1970-01-01', label: 'Contact Sales' }
      ]
    },
    compliance: [
      'FedRAMP High',
      'ITAR',
      'DOD SRG IL4',
      'DFARS 252.204-7012',
      'EAR'
    ],
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'GCC High environment' },
      { name: 'SharePoint Online', included: true, additionalInfo: 'GCC High environment' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Office Apps', included: true },
      { name: 'OneDrive for Business', included: true },
      { name: 'US Government Community Support', included: true },
      { name: 'US Data Center Locations', included: true },
      { name: 'DFARS Compliance', included: true },
      { name: 'FedRAMP High', included: true },
      { name: 'ITAR Support', included: true },
      { name: 'Microsoft Defender for Cloud Apps', included: true },
      { name: 'Microsoft Defender for Office 365', included: true },
      { name: 'Azure Government Services', included: true },
      { name: 'Teams Phone System', included: true, additionalInfo: 'Calling Plan sold separately' },
      { name: 'Power BI Pro', included: false, additionalInfo: 'Add-on available' },
    ]
  },
  {
    id: 'dod',
    name: 'Microsoft 365 DoD',
    description: 'Specifically for the US Department of Defense',
    pricing: {
      points: [
        { amount: null, currency: 'USD', unit: 'user/month', effective: '1970-01-01', label: 'Contact Sales' }
      ]
    },
    compliance: [
      'DOD SRG IL5',
      'DISA Impact Level 5',
      'NIST 800-171',
      'DFARS 252.204-7012'
    ],
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'DoD environment' },
      { name: 'SharePoint Online', included: true, additionalInfo: 'DoD environment' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Office Apps', included: true },
      { name: 'OneDrive for Business', included: true },
      { name: 'DOD-specific Support', included: true },
      { name: 'US DOD Data Centers', included: true },
      { name: 'DOD SRG IL5 Compliance', included: true },
      { name: 'DISA Impact Level 5 PA', included: true },
      { name: 'Microsoft Defender for Cloud Apps', included: true },
      { name: 'Microsoft Defender for Office 365', included: true },
      { name: 'Azure Government Services', included: true },
      { name: 'DOD-specific Security Controls', included: true },
      { name: 'Teams Phone System', included: true, additionalInfo: 'Calling Plan sold separately' },
      { name: 'Power BI Pro', included: false, additionalInfo: 'Add-on available' },
    ]
  }
];